export const baseUrl = process.env.REACT_APP_AWS_DEV_URL